import http from "../../tools/http";

export default class DealtService {
  contructor(organizationUUID, loopUUID) {
    this.organizationUUID = organizationUUID;
    this.loopUUID = loopUUID;
  }
  setOrganizationUUID(organizationUUID) {
    this.organizationUUID = organizationUUID;
  }
  setLoopUUID(loopUUID) {
    this.loopUUID = loopUUID;
  }
  getAll(pagination) {
    return http.get(`/organizations/${this.organizationUUID}/loops/${this.loopUUID}/dealts`, { params: pagination });
  }
  getOne(dealtUUID) {
    return http.get(`/organizations/${this.organizationUUID}/loops/${this.loopUUID}/dealts/${dealtUUID}`);
  }
  createDealtEvent(dealtUUID, events) {
    const formData = new FormData();
    for (const key in events) {
      formData.append(key, events[key]);
    }
    if (events.attachments) {
      for (const attachment of events.attachments) {
        formData.append(`attachments[]`, attachment);
      }
    }

    return http.post(
      `/organizations/${this.organizationUUID}/loops/${this.loopUUID}/dealts/${dealtUUID}/events`,
      formData,
      {
        headers: {
          "Content-Type": `multipart/form-data; boundary=${formData._boundary}`
        }
      }
    );
  }
}
